export default __webpack_public_path__ + "dbbcb2b7aa18d20fa6ccdb8ff52fe6aa.png";